import axios from 'axios';
//eslint-disable-next-line
import { dataURLtoFile, getFilenameFromContentDisposition } from "./misc";
import FileSaver from "file-saver";

export const hostPath = ""; // for dev change it to "http://127.0.0.1:5000";
export const apiPath = hostPath + "/api/v1.0/";
const config = {
    headers:{
        "Content-Type": "application/json",
        "Accept": "application/json"
    }
};

export const validateToken = (token) => (
    axios.get(apiPath + "ping/", {
        ...config,
        auth:{
            username: token,
            password: ""
        },
    })
);

export const get_token = (username, password, rememberMe) => (
  axios.get(apiPath + "token",{
      ...config,
      auth: {
          username: username,
          password: password
      },
      params: {
          long: rememberMe ? "true" : "false",
      }
  })
);

export const get_current_user = (token) => (
  axios.get(apiPath + "users/current", {
      ...config,
      auth: {
          username: token,
          password: ""
      }
  })
);

export const get_invalid_keys = (token, page, rows_per_page) => (
    axios.get(apiPath + "invalid_keys/",{
        ...config,
        auth: {
            username: token,
            password: "",
        },
        params: {
            page: page,
            rows_per_page: rows_per_page
        }
    })
);

export const get_invalid_keys_count = (token) => (
    axios.get(apiPath + "invalid_keys/count",{
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const post_reset_user_pass_req = (email) => (
    axios.post(apiPath + "users/req_reset_pass", JSON.stringify({
        "email":email
    }), {
        ...config,
    })
);

export const get_users = (token, page, rows_per_page) => (
    axios.get(apiPath + "users/",{
        ...config,
        auth: {
            username: token,
            password: "",
        },
        params: {
            page: page,
            rows_per_page: rows_per_page
        }
    })
);

export const post_user = (token, user) => (
    axios.post(apiPath + "users/", JSON.stringify(user),{
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const put_user = (token, user) => (
    axios.put(apiPath + `users/${user.id}`, JSON.stringify(user),{
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const del_user = (token, id) => (
    axios.delete(apiPath + `users/${id}`,{
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const get_roles = (token) => (
    axios.get(apiPath + "roles/", {
        ...config,
        auth:{
            username: token,
            password: "",
        }
    })
);

export const get_machines = (token, page, rows_per_page) => (
    axios.get(apiPath + "machines/", {
        ...config,
        auth: {
            username: token,
            password: "",
        },
        params: {
            page: page,
            rows_per_page: rows_per_page
        }
    })
);

export const get_machine = (token, id) => (
    axios.get(apiPath + `machines/${id}`, {
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const post_machine = (token, machine) => (
    axios.post(apiPath + "machines/", JSON.stringify(machine), {
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const put_machine = (token, machine) => (
    axios.put(apiPath + `machines/${machine.id}`, JSON.stringify(machine), {
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const del_machine = (token, id) => (
    axios.delete(apiPath + `machines/${id}`, {
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const get_orders = (token, page, rows_per_page, fromTime, toTime, payment_type, machines, order_by, desc) => (
    axios.get(apiPath + "orders/" , {
        ...config,
        auth: {
            username: token,
            password: "",
        },
        params: {
            rows_per_page: rows_per_page,
            page: page,
            from_time: fromTime,
            to_time: toTime,
            payment_type: payment_type,
            machines: machines,
            order_by: order_by,
            desc: desc,
        }
    })
);

export const get_encashments = (token, page, rows_per_page, fromTime, toTime, machines, order_by, desc) => (
    axios.get(apiPath + "encashments/",{
        ...config,
        auth: {
            username: token,
            password: "",
        },
        params: {
            rows_per_page: rows_per_page,
            page: page,from_time: fromTime,
            to_time: toTime,
            machines: machines,
            order_by: order_by,
            desc: desc,
        }
    })
);

export const get_keys = (token, page, rows_per_page, search_query, type) => (
    axios.get(apiPath + "keys/",{
        ...config,
        auth: {
            username: token,
            password: "",
        },
        params: {
            rows_per_page: rows_per_page,
            page: page,
            search_query: search_query,
            type: type,
        }
    })
);

export const get_key = (token, id) =>  (
    axios.get(apiPath + `keys/${id}`,{
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const get_key_transactions = (token, key_id, page, rows_per_page) => (
    axios.get(apiPath + `keys/${key_id}/transactions`, {
        ...config,
        auth: {
            username: token,
            password: "",
        },
        params: {
            page: page,
            rows_per_page: rows_per_page,
        }
    })
);

export const post_key = (token, key) => (
    axios.post(apiPath+ "keys/", JSON.stringify(key), {
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const put_key = (token, key) => (
    axios.put(apiPath + `keys/${key.id}`, JSON.stringify(key), {
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const delete_key = (token, id) => (
    axios.delete(apiPath + `keys/${id}`, {
        ...config,
        auth: {
            username: token,
            password: ""
        }
    })
);

export const get_key_types = (token) => (
    axios.get(apiPath + "key_types/", {
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const get_machines_ids = (token) => (
    axios.get(apiPath + "machines/",{
        ...config,
        auth: {
            username: token,
            password: "",
        },
        params: {
            only: 'id',
        }
    })
);

export const get_file = (token, route_suffix, params) => (
    axios.get(apiPath + route_suffix, {
        auth: {
            username: token,
            password: ""
        },
        params: params,
        responseType: "blob",
    }).then((response) => {
        const blob = new Blob([response.data], {type:response.headers["content-type"]});
        FileSaver.saveAs(blob, getFilenameFromContentDisposition(response.headers["content-disposition"]));
    })
);

export const get_daily_sales = (token, year, month, type) => (
    axios.get(apiPath + "statistics/daily_sales", {
        ...config,
        auth: {
            username: token,
            password: "",
        },
        params: {
            year: year,
            month: month,
            type: type,
        }
    })
);

export const get_machine_daily_sales = (token, id, year, month, type) => (
    axios.get(apiPath + `machines/${id}/daily_sales`, {
        ...config,
        auth: {
            username: token,
            password: "",
        },
        params: {
            year: year,
            month: month,
            type: type,
        }
    })
);

export const get_month_sum_sales = (token, year, type) => (
    axios.get(apiPath + "statistics/month_sum_sales", {
        ...config,
        auth: {
            username: token,
            password: "",
        },
        params: {
            year: year,
            type: type,
        }
    })
);

export const get_month_avg_sales = (token, year, type) => (
    axios.get(apiPath + "statistics/month_avg_sales", {
        ...config,
        auth: {
            username: token,
            password: "",
        },
        params: {
            year: year,
            type: type,
        }
    })
);

export const get_payment_types_share_in_sales = (token, machines, fromTime, toTime, type) => (
    axios.get(apiPath + "statistics/payment_types_share_in_sales", {
        ...config,
        auth: {
            username: token,
            password: "",
        },
        params: {
            machines: machines,
            type: type,
            from_time: fromTime,
            to_time: toTime,
        }
    })
);

export const get_machines_addresses = (token) => (
    axios.get(apiPath + "machines/", {
        ...config,
        auth: {
            username: token,
            password: "",
        },
        params: {
            only: 'address',
        }
    })
);

export const get_daily_sales_count = (token, year, month) => (
    axios.get(apiPath + "statistics/daily_sales_count", {
        ...config,
        auth: {
            username: token,
            password: "",
        },
        params: {
            year: year,
            month: month,
        }
    })
);

export const get_organizations = (token, page, rows_per_page) => (
    axios.get(apiPath + "organizations/", {
        ...config,
        auth: {
            username: token,
            password: "",
        },
        params: {
            page: page,
            rows_per_page: rows_per_page,
        }
    })
);

export const get_organization = (token, id) => (
    axios.get(apiPath + `organizations/${id}`, {
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const post_organization = (token, organization) => (
    axios.post(apiPath + "organizations/", JSON.stringify(organization), {
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const put_organization = (token, organization) => (
    axios.put(apiPath + `organizations/${organization.id}`, JSON.stringify(organization), {
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const delete_organization = (token, id) => (
    axios.delete(apiPath + `organizations/${id}`, {
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const get_uesrs_organizations = (token) => (
    axios.get(apiPath + "organizations/",{
        ...config,
        auth: {
            username: token,
            password: "",
        },
        params: {
            all: true
        }
    })
);

export const get_machine_reset_refill = (token, id) => (
    axios.get(apiPath + `machines/${id}/reset_refill`, {
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const get_reports = (token, page, rows_per_page, from_time, to_time, not_accepted, active, order_by, desc) => (
    axios.get(apiPath + "reports/", {
        ...config,
        auth: {
            username: token,
            password: "",
        },
        params: {
            page: page,
            rows_per_page: rows_per_page,
            from_time: from_time,
            to_time: to_time,
            not_accepted: not_accepted,
            active: active,
            order_by: order_by,
            desc: desc
        }
    })
);

export const get_report_apply = (token, id) => (
    axios.get(apiPath + `reports/${id}/accept`, {
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const get_report_next = (token, id) => (
    axios.get(apiPath + `reports/${id}/next`, {
        ...config,
        auth: {
            username: token,
            password: ""
        }
    })
);

export const post_report = (token, report) => (
    axios.post(apiPath + "reports/", JSON.stringify(report), {
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const get_reports_subjects = (token) => (
    axios.get(apiPath + "reports_subjects/", {
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const  get_report = (token, id) => (
    axios.get(apiPath + `reports/${id}`, {
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const delete_report = (token, id) => (
    axios.delete(apiPath + `reports/${id}`, {
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const put_report = (token, report) => (
    axios.put(apiPath + `reports/${report.id}`, JSON.stringify(report), {
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const get_reports_works = (token) => (
    axios.get(apiPath + "reports_works/", {
        ...config,
        auth: {
            username: token,
            password: "",
        }
    })
);

export const post_report_image = (token, report_id,  image) => {
    let formData = new FormData();
    formData.append("file", image);
    return axios.post(apiPath + `reports/${report_id}/image`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        auth: {
            username: token,
            password: ""
        }
    })
};

export const post_user_push_token = (token, push_token) => (
    axios.post(apiPath + "users/current/push_token", JSON.stringify({
        token: push_token
    }),{
        ...config,
        auth: {
            username: token,
            password: ""
        }
    })
);

export const get_keys_transactions = (token, page, rows_per_page, from_time, to_time, order_by, desc, search_query) => (
    axios.get(apiPath + "keys_transactions/", {
        ...config,
        auth: {
            username: token,
            password: "",
        },
        params: {
            page: page,
            rows_per_page: rows_per_page,
            from_time: from_time,
            to_time: to_time,
            order_by: order_by,
            desc: desc,
            search_query: search_query
        }
    })
);

export const get_logs_uri = (machine_id, from_time, to_time, limit) => (
    `${apiPath}logs/?plain=true&machine_id=${machine_id}&from_time=${from_time}&to_time=${to_time}&limit=${limit}`
)

export const get_logs = (token, machine_id, from_time, to_time, limit) => (
    axios.get(apiPath + "logs/", {
        headers: {
            "Accept": "text/plain"
        },
        auth: {
            username: token,
            password: "",
        },
        params: {
            plain: true,
            machine_id: machine_id,
            from_time: from_time,
            to_time: to_time,
            limit: limit,
        }
    })
);

export const get_notifications = (token) => (
    axios.get(apiPath + "notifications/", {
        auth: {
            username: token,
            password: "",
        }
    })
);

export const get_notifications_viewed = (token) => (
    axios.get(apiPath + "notifications/viewed", {
        auth: {
            username: token,
            password: "",
        }
    })
);


// WEBPACK FOOTER //
// ./src/utils/http.js